import { SxyGridController } from "../../controllers";

import { Objects } from "@salaxy/core";

import { ComponentBase } from "../_ComponentBase";

/**
 * Shows a grid component for view / edit of arrays.
 * @example
 * ```html
 * <sxy-grid schema="UserDefinedRow" data="$ctrl.temp"></sxy-grid>
 * ```
 */
export class SxyGrid extends ComponentBase {

    /** sxy-form is optional */
    public require = {
        form: "?^^sxyForm",
    };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = Objects.extend(SxyGridController.bindings , {});

    /** Uses the SxyGridController */
    public controller = SxyGridController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/sxy-form/SxyGrid.html";
}
